import React, { useEffect, useState, useRef } from 'react';
import './Project.css';

import { ProjectItem, ProjectTabs } from '../../components';
import { projects } from '../../constants';

import Isotope from 'isotope-layout';
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";



const Project = () => {

  // State
  const [category, setCategory] = useState('all');
  const iso = useRef(null);
  const gridRef = useRef(null);

  // Lightbox State
  const [index, setIndex] = useState(-1);
  const currentImage = projects[index];
  const nextIndex = (index + 1) % projects.length;
  const nextImage = projects[nextIndex] || currentImage;
  const prevIndex = (index + projects.length - 1) % projects.length;
  const prevImage = projects[prevIndex] || currentImage;

  const openLightbox = (index) => setIndex(index);
  const closeLightbox = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  // Function to format category names as Isotope classes
  const formatCategory = (name) => name.toLowerCase().replace(/\s+/g, '-');

  // Get unique categories from projects
  const categories = ['all', ...new Set(projects.map(item => formatCategory(item.details.category)))];

  // Initialize Isotope
  useEffect(() => {
    iso.current = new Isotope(gridRef.current, {
      itemSelector: '.project-item',
      layoutMode: 'fitRows',
    });

    return () => {
      iso.current.destroy();
    };
  }, []);

  // Apply filter when category changes
  useEffect(() => {
    if (iso.current) {
      iso.current.arrange({
        filter: category === 'all' ? '*' : `.${category}`, // Filters by class name
      });
    }
  }, [category]);

  return (
    <div className='projects'>

      {/* Project Tabs */}
      <ul className="tab-buttons">
        {categories.map((item) => (
          <ProjectTabs
            key={item}
            id={item}
            title={item.replace(/-/g, ' ')} // Show original category name
            setSelected={() => setCategory(item)}
            active={category === item}
          />
        ))}
      </ul>

      {/* Project Grid */}
      <div className="box-container" ref={gridRef}>
        {projects.map((item, index) => {
          const className = formatCategory(item.details.category);
          return (
            <ProjectItem
              key={item.id}
              id={index}
              image={item.image}
              title={item.title}
              category={item.details.category}
              project={item}
              className={`project-item ${className}`} // Add class for Isotope filtering
              popup={openLightbox}
            />
          );
        })}
      </div>

      {/* Lightbox */}
      {index !== -1 && (
        <Lightbox
          mainSrc={currentImage.image}
          imageTitle={currentImage.title}
          mainSrcThumbnail={currentImage.image}
          nextSrc={nextImage.image}
          nextSrcThumbnail={nextImage.image}
          prevSrc={prevImage.image}
          prevSrcThumbnail={prevImage.image}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
    </div>
  );
};

export default Project;